import React from 'react';

const FESkills = () => {
    return (
        <React.Fragment>
            <div className="block-title">
                <h3>Miscellaneous Skills</h3>
            </div>
            <div className="skills-info">
                <h4>Progressive Web Application</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
                <h4>Multithreading</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
                <h4>Object Oriented Analysis and Design</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-7" />
                </div>
                <h4>TDD</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-5" />
                </div>
                <h4>User Analytics</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-4" />
                </div>
            </div>
        </React.Fragment>
    );
};

export default FESkills;